var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/Cloud/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/customer-info.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-customer-info ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "alert"), env.opts.autoescape);
output += "\">\n\t<div id=\"minutes-used\">\n\t\t<div id=\"minutes-total\">\n\t\t\tTotal minutes used:\n\t\t\t<span class=\"cm-value\">";
output += runtime.suppressValue(env.getFilter("number").call(context, runtime.contextOrFrameLookup(context, frame, "minutesUsed")), env.opts.autoescape);
output += "</span></div>\n\t\t<div id=\"minutes-7-day\">\n\t\t\tMinutes used for the last 7 day:\n\t\t\t<span class=\"cm-value\">";
output += runtime.suppressValue(env.getFilter("number").call(context, runtime.contextOrFrameLookup(context, frame, "minutesLast7Days")), env.opts.autoescape);
output += "</span>\n\t\t\t<span class=\"cm-value cm-previous\">[ ";
output += runtime.suppressValue(env.getFilter("number").call(context, runtime.contextOrFrameLookup(context, frame, "minutesPrevious7Days")), env.opts.autoescape);
output += " ]</span>\n\t\t\t<i class=\"fa fa-arrow-";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "minutesLast7Days") > runtime.contextOrFrameLookup(context, frame, "minutesPrevious7Days")?"up":"down"), env.opts.autoescape);
output += "\"></i>\n\t\t</div>\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "imagesGenerated") != runtime.contextOrFrameLookup(context, frame, "undefined")) {
output += "<div id=\"images-generated\">\n\t\t\tTotal images generated: <span class=\"cm-value\">";
output += runtime.suppressValue(env.getFilter("number").call(context, runtime.contextOrFrameLookup(context, frame, "imagesGenerated")), env.opts.autoescape);
output += "</span>\n\t\t</div>";
;
}
output += "\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "imagesBudget") != runtime.contextOrFrameLookup(context, frame, "undefined")) {
output += "<div id=\"images-budget\">\n\t\t\tRemaining images: <span class=\"cm-value\">";
output += runtime.suppressValue(env.getFilter("number").call(context, runtime.contextOrFrameLookup(context, frame, "imagesBudget")), env.opts.autoescape);
output += "</span>\n\t\t</div>";
;
}
output += "\n\t</div>\n\t";
if(runtime.contextOrFrameLookup(context, frame, "allowance") != runtime.contextOrFrameLookup(context, frame, "undefined") && runtime.contextOrFrameLookup(context, frame, "alertTime")) {
output += "<div id=\"estimated-time\">\n\t\t<div id=\"minutes-remaining\">\n\t\t\tRemaining minutes: <span class=\"cm-value\">";
output += runtime.suppressValue(env.getFilter("number").call(context, runtime.contextOrFrameLookup(context, frame, "allowance")), env.opts.autoescape);
output += "</span>\n\t\t</div>\n\t\t<div id=\"alert-time\">\n\t\t\tEstimated alert time:\n\t\t\t<span class=\"cm-date-time\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "alertTime"),"dddd, MMMM Do YYYY, h:[00]a"), env.opts.autoescape);
output += "</span>\n\t\t</div>\n\t</div>";
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/customer-info.html"] , dependencies)